// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { ExecutedMint } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Model/Mint';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useQueryWithOptions } from '../../../other/useQueryWithOptions';

export const useExecutedMints2Step: () => UseQueryResult<
  TemplateContract<ExecutedMint>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  return useQueryWithOptions({
    queryKey: ['queryExecutedMintsTwoStep'],
    queryFn: async (_, options) => {
      return ledgerApi.query(options, ExecutedMint);
    },
  });
};
